import { render } from "./OverdueTasks.vue?vue&type=template&id=96474378"
import script from "./OverdueTasks.vue?vue&type=script&lang=js"
export * from "./OverdueTasks.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__